import { render, staticRenderFns } from "./PopupAddFromTemplate.vue?vue&type=template&id=13c38ea0&"
import script from "./PopupAddFromTemplate.vue?vue&type=script&lang=js&"
export * from "./PopupAddFromTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddFromTemplate.vue?vue&type=style&index=0&id=13c38ea0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports